/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsProductPermissions,
    MelcoModelsProductPermissionsFromJSON,
    MelcoModelsProductPermissionsFromJSONTyped,
    MelcoModelsProductPermissionsToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsProductPermissions
 */
export interface MelcoModelsGenericList1MelcoModelsProductPermissions {
    /**
     * 
     * @type {Array<MelcoModelsProductPermissions>}
     * @memberof MelcoModelsGenericList1MelcoModelsProductPermissions
     */
    list: Array<MelcoModelsProductPermissions>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsProductPermissions
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsProductPermissions
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsProductPermissionsFromJSON(json: any): MelcoModelsGenericList1MelcoModelsProductPermissions {
    return MelcoModelsGenericList1MelcoModelsProductPermissionsFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsProductPermissionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsProductPermissions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsProductPermissionsFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsProductPermissionsToJSON(value?: MelcoModelsGenericList1MelcoModelsProductPermissions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsProductPermissionsToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


